<template>
    <div>
        <LiefengContent>
            <template v-slot:title>{{ "banner管理" }}</template>
            <template #toolsbarRight>
                <Form :label-colon="true" :inline="true" class="search">
                    <Button style="margin-right: 10px" type="info" @click="addBtn">新增</Button>
                </Form>
            </template>
            <template v-slot:contentArea>
                <LiefengTable
                    :talbeColumns="talbeColumns"
                    :tableData="tableData"
                    :loading="loading"
                    :fixTable="true"
                    :curPage="page"
                    :total="total"
                    :pagesizeOpts="[20, 30, 50, 100]"
                    :page-size="pageSize"
                    @hadlePageSize="hadlePageSize"
                    @tableSelect="tableSelect"
                ></LiefengTable>
            </template>
        </LiefengContent>
        <!-- 新增修改界面 -->
        <LiefengModal :title="editType == 'add' ? '新增' : '修改'" :value="editStatus" @input="changeEditStatus" width="600px" height="450px">
            <template v-slot:contentarea>
                <Form :label-width="120">
                    <FormItem>
                        <span slot="label" class="validate">标题:</span>
                        <Input v-model.trim="formData.title" style="width: 300px"></Input>
                    </FormItem>
                    <FormItem>
                        <span slot="label" class="validate">应用:</span>
                        <Select v-model="formData.appCode" style="width: 300px">
                            <Option value="suiyue_weapp">随约</Option>
                            <Option value="suiyueyouxuan_weapp">随约优选</Option>
                            <Option value="suiyue_xcx_hzq081">滨江未来家</Option>
                            <Option value="suiyue_xcx_P440605123001">慈爱一键通</Option>
                            <Option value="suiyue_xcx_hzq078">滨江未来+</Option>
                            <Option value="leifengnetwork">雷锋网</Option>
                        </Select>
                    </FormItem>
                    <FormItem>
                        <span slot="label" class="validate">位置:</span>
                        <Select v-model="formData.position" style="width: 300px">
                            <Option :value="'1'">启动页</Option>
                            <Option :value="'2'">首页</Option>
                            <Option :value="'3'">其他</Option>
                        </Select>
                    </FormItem>
                    <FormItem>
                        <span slot="label" class="validate">关联类型:</span>
                        <RadioGroup v-model="formData.bannerType">
                            <Radio label="-5">内容详情</Radio>
                            <Radio label="-1">内容列表</Radio>
                            <Radio label="-2">页面</Radio>
                            <Radio label="-3">第三方链接</Radio>
                            <Radio label="-4">小程序</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem>
                        <span slot="label" class="validate">跳转链接:</span>
                        <Input v-model.trim="formData.bannerLink" style="width: 300px"></Input>
                    </FormItem>
                    <FormItem>
                        <span slot="label" class="validate">排序:</span>
                        <InputNumber :min="1" :max="999999999" v-model="formData.sort"></InputNumber>
                    </FormItem>
                    <FormItem>
                        <span slot="label" class="validate">背景:</span>
                        <RadioGroup v-model="formData.bannerBg">
                            <Radio label="icon">图标</Radio>
                            <Radio label="image">背景</Radio>
                        </RadioGroup>
                        <LiefengUpload ref="imgData" v-if="showImage" accept=".jpg,.png,.gif,.jpeg" :format="['jpg', 'png', 'jpeg', 'gif']" :defaultList="imgData" :showView="true"></LiefengUpload>
                    </FormItem>
                </Form>
            </template>
            <template v-slot:toolsbar>
                <Button style="margin-right: 10px" type="primary" @click="save">保存</Button>
                <Button style="margin-right: 10px" type="info" @click="changeEditStatus(false)">关闭</Button>
            </template>
        </LiefengModal>

        <LiefengModal :title="'设置范围'" width="1000px" :value="addModal.status" @input="addModalData" class="export-modal" style="max-width: 1000px">
            <template v-slot:contentarea>
                <Form :label-width="120">
                    <FormItem>
                        <span slot="label" class="validate">设置范围:</span>
                        <LiefengCascaderCity
                            v-if="showCascader"
                            @changeCasader="changeCasader"
                            :resetNum="resetNum"
                            :isShow="isShow"
                            :orgCode="44"
                            :width="400"
                            :isClear="true"
                            :value="dataScopeList"
                        ></LiefengCascaderCity>
                    </FormItem>
                </Form>
                <LiefengTable
                    :talbeColumns="talbeColumns2"
                    :tableData="tableData2"
                    :fixTable="false"
                    :hidePage="true"
                ></LiefengTable>
            </template>
            <template #toolsbar>
                <Button type="primary" style="margin-right: 10px" icon="ios-share-outline" @click="submit()">保存</Button>
                <Button type="info" @click="addModalData(false)">取消</Button>
            </template>
        </LiefengModal>
    </div>
</template>

<script>
import LiefengContent from "@/components/LiefengContent3"
import LiefengTable from "@/components/LiefengTable"
import LiefengModal from "@/components/LiefengModal"
import LiefengUpload from "@/components/LiefengUpload"
import LiefengCascaderCity from "@/components/LiefengCascaderCity"
// import AddFrom from "./components/addForm.vue"
export default {
    components: { LiefengContent, LiefengTable, LiefengModal, LiefengUpload, LiefengCascaderCity },
    data() {
        return {
            searchData: { title: "" },
            // table表格数据
            tableData: [],
            loading: false,
            page: 1,
            pageSize: 20,
            total: 0,
            currentPage: 0,
            talbeColumns: [
                {
                    title: "标题",
                    minWidth: 400,
                    align: "center",
                    key: "title",
                },
                {
                    title: "应用",
                    minWidth: 150,
                    align: "center",
                    key: "appCode",
                    render: (h, params) => {
                        return h(
                            "span",
                            params.row.appCode === "suiyue_weapp" ? "随约" :
                                params.row.appCode === "suiyue_xcx_hzq078" ?
                                    '滨江未来+': params.row.appCode === "suiyue_xcx_hzq081" ?
                                    '雷锋网': params.row.appCode === "leifengnetwork" ?
                                        '滨江未来家' : params.row.appCode === "suiyue_xcx_P440605123001" ?  '慈爱一键通' : "随约优选"
                        )
                    }
                },
                {
                    title: "位置",
                    minWidth: 100,
                    align: "center",
                    key: "position",
                    render: (h, params) => {
                        const positionMap = {
                            1: "启动页",
                            2: "首页",
                            3: "其他"
                        }
                        return h(
                            "span",
                            positionMap[params.row.position] || "-"
                        )
                    }
                },
                {
                    title: "类型",
                    minWidth: 200,
                    align: "center",
                    key: "bannerType",
                    render: (h, params) => {
                        return h(
                            "span",
                            {
                                style: {
                                    dispiay: "inline-block",
                                    backgroundColor: "#D3F4F4",
                                    padding: "20px 10px",
                                    color: "#24C8C8",
                                },
                            },
                            params.row.bannerType == "-5"
                                ? "内容详情"
                                : params.row.bannerType == "-1"
                                ? "内容列表"
                                : params.row.bannerType == "-2"
                                ? "页面"
                                : params.row.bannerType == "-3"
                                ? "第三方链接"
                                : params.row.bannerType == "0"
                                ? "信息"
                                : "小程序"
                        )
                    },
                },
                {
                    title: "链接",
                    minWidth: 400,
                    align: "center",
                    key: "bannerLink",
                },
                {
                    title: "排序",
                    minWidth: 100,
                    align: "center",
                    key: "sort",
                },
                {
                    title: "背景",
                    minWidth: 200,
                    align: "center",
                    render: (h, params) => {
                        return h("div", [
                            h("Avatar", {
                                props: {
                                    src: params.row.images,
                                },
                            }),
                        ])
                    },
                },
                {
                    title: "状态",
                    key: "status",
                    minWidth: 200,
                    align: "center",
                    render: (h, params) => {
                        return h("i-Switch", {
                            props: {
                                size: "large",
                                value: params.row.status == 1,
                            },
                            scopedSlots: {
                                open: () => h("span", "启用"),
                                close: () => h("span", "停用"),
                            },
                            on: {
                                "on-change": () => {
                                    // console.log(params.row);
                                    this.formData = {
                                        ...params.row,
                                        status: params.row.status == 1 ? 2 : 1,
                                    }
                                    delete this.formData._index
                                    delete this.formData._rowKey
                                    this.upData()
                                },
                            },
                        })
                    },
                    // render:(h,params) =>{
                    //   return h('div',{},params.row.status == 1 ?'正常':'禁用' )
                    // }
                },
                {
                    title: "操作",
                    align: "center",
                    fixed: "right",
                    width: 250,
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    textAlign: "center",
                                },
                            },
                            [
                                h(
                                    "span",
                                    {
                                        on: {
                                            click: () => {
                                                this.appBannerId = params.row.appBannerId
                                                this.setScoped(params.row.appBannerId)
                                            },
                                        },
                                        style: {
                                            width: "65px",
                                            marginRight: "10px",
                                            textAlign: "center",
                                            color: "#2d8cf0",
                                            cursor: "pointer",
                                            userSelect: "none",
                                        },
                                    },
                                    "设置范围" //1001
                                ),
                                h(
                                    "span",
                                    {
                                        on: {
                                            click: () => {
                                                this.edit(params.row.appBannerId)
                                            },
                                        },
                                        style: {
                                            width: "65px",
                                            marginRight: "10px",
                                            textAlign: "center",
                                            color: "#2d8cf0",
                                            cursor: "pointer",
                                            userSelect: "none",
                                        },
                                    },
                                    "修改" //1001
                                ),
                                h(
                                    "span",
                                    {
                                        on: {
                                            click: () => {
                                                this.delete(params.row.appBannerId)
                                            },
                                        },
                                        style: {
                                            width: "65px",
                                            marginRight: "10px",
                                            textAlign: "center",
                                            color: "#2d8cf0",
                                            cursor: "pointer",
                                            userSelect: "none",
                                        },
                                    },
                                    "删除" //1001
                                ),
                            ]
                        )
                    },
                },
            ],

            // 分享并预览模态框状态
            officialStatus: false,

            // 存放点击分享并预览的时候点击的当前的infoId
            qrCodeId: "",
            qrOCdeName: "", //信息标题
            codeString: "", // 传给组件的code

            // 新增修改参数
            formData: {
                appBannerId: "",
                appCode: "suiyue_weapp",
                title: "",
                images: "",
                bannerType: "-5",
                bannerLink: "",
                bannerBg: "icon",
                status: "1",
                sort: 0,
                position:'',
                appCode:'',
            },
            editType: "",
            showImage: true,
            imgData: [],
            editStatus: false,

            addModal: {
                status: false,
            },
            showCascader: false,

            appBannerId: "",

            dataScopeList: "",
            scopeId: "",
            resetNum: 1, // 是否清空当前社区选择
            cascaderList: [],

            isShow: false,

            talbeColumns2:[ {
                    title: "范围名称",
                    minWidth: 400,
                    align: "center",
                    key: "orgName",
                },
                {
                    title: "操作",
                    align: "center",
                    fixed: "right",
                    width: 250,
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    textAlign: "center",
                                },
                            },
                            [
                                h(
                                    "span",
                                    {
                                        on: {
                                            click: () => {
                                                this.$post('/gateway/lf-common/api/lfcommon/pc/appBanner/deleteAppBannerScope',{
                                                    scopeId:params.row.scopeId
                                                }).then(res=>{
                                                    if(res.code == 200){
                                                        this.$Message.success({
                                                            content:'删除成功',
                                                            background:true
                                                        })
                                                        this.setScoped(this.appBannerId)
                                                    }else{
                                                        this.$Message.error({
                                                            content:'删除失败',
                                                            background:true
                                                        })
                                                    }
                                                })
                                            },
                                        },
                                        style: {
                                            width: "65px",
                                            marginRight: "10px",
                                            textAlign: "center",
                                            color: "#2d8cf0",
                                            cursor: "pointer",
                                            userSelect: "none",
                                        },
                                    },
                                    "删除" //1001
                                ),
                            ]
                        )
                    },
                },],
            tableData2:[
               
            ]
        }
    },
    created() {
        this.getList()
    },
    methods: {
        changeCasader(val) {
            this.cascaderList = val
            if (!val.length) {
                this.resetNum++
            }
        },
        submit() {
            let params = {
                scopeId: this.scopeId, //修改传入
                appBannerId: this.appBannerId,
                dataScopeId: this.cascaderList && this.cascaderList.length ? `44-${this.cascaderList.join("-")}` : '',
            }
            this.saveAppBannerScope(params)
        },
        addModalData(status) {
            this.addModal.status = status
        },
        // 点击设置范围按钮
        setScoped(appBannerId) {
            this.$get("/gateway/lf-common/api/lfcommon/pc/appBanner/getAppBannerScope", {
                appBannerId,
            }).then(res => {
                if (res && res.code == 200) {
                    this.showCascader = false
                    this.$nextTick(() => {
                        this.showCascader = true
                        this.tableData2 = res.dataList
                        // if (res.dataList && res.dataList.length && res.dataList[0].dataScopeId && res.dataList[0].dataScopeId != '') {
                        //     this.dataScopeList = ""
                        //     this.scopeId = res.dataList[0].scopeId
                        //     this.isShow = true
                        //     if (res.dataList[0].dataScopeId && res.dataList[0].dataScopeId != "") {
                        //         var list = res.dataList[0].dataScopeId.split("-")
                        //         if (list.length == 5) {
                        //             this.dataScopeList = [list[1],list[2],list[3],list[4]] 
                        //         } else if (list.length == 4) {
                        //             this.dataScopeList = [list[1],list[2],list[3]] 
                        //         } else if (list.length == 3) {
                        //             this.dataScopeList = [list[1],list[2]] 
                        //         } else if(list.length == 2){
                        //             this.dataScopeList = [list[1]] 
                        //         }
                        //         console.log("this.dataScopeList", this.dataScopeList)
                        //     }
                        // } else {
                        //     this.isShow = false
                        //     this.scopeId = ""
                        //     this.dataScopeList = ""
                        // }
                    })

                    this.addModalData(true)
                } else {
                    this.$Message.error({
                        background: true,
                        content: "获取范围失败",
                    })
                    return
                }
            })
        },
        // 方法部分
        changeEditStatus(val) {
            if (!val)
                (this.formData = {
                    bannerType: "-1",
                    photoType: "image",
                    sort: 1,
                }),
                    (this.imgData = [])
            this.showImage = false
            this.$nextTick(() => {
                this.showImage = true
            })
            this.editStatus = val
        },
        edit(id) {
            this.editType = "upData"
            this.$get("/gateway/lf-common/api/lfcommon/pc/appBanner/queryById", {
                appBannerId: id,
            }).then(res => {
                this.editStatus = true
                if (res.code == 200) {
                    this.showImage = false
                    this.$nextTick(() => {
                        this.showImage = true
                        let data = JSON.parse(JSON.stringify(res.data))
                        this.imgData = [{ name: "", url: data.images }]
                        this.formData = data
                    })
                }
            })
        },
        delete(appBannerId) {
            this.$Modal.confirm({
                title: "删除确定",
                content: "是否删除当前链接",
                onOk: () => {
                    this.$post("/gateway/lf-common/api/lfcommon/pc/appBanner/deleteById", {
                        appBannerId,
                    }).then(res => {
                        if (res.code == 200) {
                            this.$Message.success({
                                content: "删除成功",
                                background: true,
                            })
                            this.getList()
                        } else {
                            this.$Message.error({
                                content: res.desc,
                                background: true,
                            })
                            return
                        }
                    })
                },
            })
        },
        // 保存按钮
        save() {
            if (!this.formData.appCode) {
                this.$Message.warning({
                    content: "请选择应用",
                    background: true,
                })
                return
            }
            if (!this.formData.position) {
                this.$Message.warning({
                    content: "请选择位置",
                    background: true,
                })
                return
            }
            if (!this.formData.title) {
                this.$Message.warning({
                    content: "请输入标题",
                    background: true,
                })
                return
            }
            if (!this.formData.bannerType) {
                this.$Message.warning({
                    content: "请选择关联类型",
                    background: true,
                })
                return
            }
            if (!this.formData.bannerLink) {
                this.$Message.warning({
                    content: "请输入跳转链接",
                    background: true,
                })
                return
            }
            if (!this.formData.bannerBg) {
                this.$Message.warning({
                    content: "请选择背景类型",
                    background: true,
                })
                return
            }
            if (this.$refs.imgData.uploadList.length == 0) {
                this.$Message.warning({
                    content: "请添加图片",
                    background: true,
                })
                return
            } else {
                this.formData.images = this.$refs.imgData.uploadList[0].url
            }
            if (this.editType == "add") {
                this.add()
            } else {
                this.upData()
            }
        },
        add() {
            this.$post(
                "/gateway/lf-common/api/lfcommon/pc/appBanner/saveAppBanner",
                {
                    ...this.formData,
                },
                { "Content-Type": "application/json" }
            ).then(res => {
                if (res.code == 200) {
                    this.$Message.success({
                        content: "新增成功",
                        background: true,
                    })
                    this.showImage = false
                    this.$nextTick(() => {
                        this.showImage = true
                    })
                    this.editStatus = false
                    this.getList()
                } else {
                    this.$Message.error({
                        content: res.desc,
                        background: true,
                    })
                }
            })
        },
        upData() {
            this.$post(
                "/gateway/lf-common/api/lfcommon/pc/appBanner/saveAppBanner",
                {
                    ...this.formData,
                },
                { "Content-Type": "application/json" }
            ).then(res => {
                if (res.code == 200) {
                    this.$Message.success({
                        content: "修改成功",
                        background: true,
                    })
                    this.showImage = false
                    this.$nextTick(() => {
                        this.showImage = true
                    })
                    this.editStatus = false
                    this.getList()
                } else {
                    this.$Message.error({
                        content: res.desc,
                        background: true,
                    })
                }
            })
        },
        // 重置按钮
        resetBtn() {
            this.page = 1
            this.getList()
        },
        addBtn() {
            this.editType = "add"
            this.editStatus = true
            this.imgData = []
            this.showImage = false
            this.formData = {
                appBannerId: "",
                appCode: "suiyue_weapp",
                title: "",
                images: "",
                bannerType: "-5",
                bannerLink: "",
                bannerBg: "icon",
                status: "1",
                sort: 0,
                position: '',
                appCode:'',
            }
            this.$nextTick(() => {
                this.showImage = true
            })
            this.openStatusFn(true)
        },
        // 分页改变接口
        hadlePageSize(val) {
            this.page = val.page
            this.pageSize = val.pageSize
            this.getList()
        },
        // 接口部分
        getList() {
            this.loading = true
            this.$get("/gateway/lf-common/api/lfcommon/pc/appBanner/selectAppBannerPage", {
                appCode: "suiyue_weapp",
                page: this.page,
                pageSize: this.pageSize,
            }).then(res => {
                this.loading = false
                if (res && res.code && res.code == 200 && res.dataList) {
                    this.tableData = res.dataList
                    this.total = res.maxCount
                    this.currentPage = res.currentPage
                } else {
                    this.$Message.error({
                        content: "获取数据失败",
                        background: true,
                    })
                    return
                }
            })
        },

        saveAppBannerScope(params) {
            this.$Message.loading({
                title: "正在设置中",
            })
            this.$post(
                "/gateway/lf-common/api/lfcommon/pc/appBanner/saveAppBannerScope",
                {
                    ...params,
                },
                {
                    "Content-Type": "application/json",
                }
            ).then(res => {
                this.$Message.destroy()
                if (res && res.code == 200) {
                    this.$Message.success({
                        content: "设置成功",
                        background: true,
                    })
                    this.addModalData(false)
                    return
                } else {
                    this.$Message.error({
                        content: "设置失败",
                        background: true,
                    })
                    return
                }
            })
        },
    },
}
</script>
<style lang="less">
.operation-title {
    &::after {
        content: ">";
        position: "absolute";
        transform: rotate(90deg);
        display: block;
        margin-left: 2px;
        font-size: 10px;
    }
}
</style>
<style lang="less" scoped>
.table-left {
    float: left;
    width: 160px;
    /deep/.ivu-menu {
        width: 160px !important;
    }
}
.none-modal {
    /deep/.ivu-modal-close {
        display: none;
    }
}
/deep/.validate {
    &::before {
        content: "*";
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 14px;
        color: #ed4014;
    }
}
/deep/.ivu-tooltip-inner {
    width: 200px;
    white-space: normal;
}
/deep/.ivu-menu-item {
    z-index: 3;
}
</style>